import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function InventoryWarning() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
